import { FULL_MOMENTO_DATA_PROVIDERS } from '../dataProviders';
import { Expansion, ExpansionPatch } from '../expansion';
import { FAR_FUTURE_DATE } from '../sharedConstants';
import {
  CURRENT_TIER_CROSSSERVER_RAID_KILLCOUNT,
  CURRENT_TIER_RAID_KILLCOUNT,
  PREVIOUS_TIER_RAID_KILLCOUNT,
  PREVIOUS_XPAC_RAID_KILLCOUNT
} from './constants';
import {
  DF_LAUNCH_DATE,
  DF_PREPATCH_LAUNCH_DATES,
  DF_SEASON1_DATES,
  DF_SEASON2_DATES,
  DF_SEASON3_DATES,
  DF_SEASON4_DATES,
  MIDNIGHT_GLOBAL_LAUNCH_DATES,
  TWW_SEASON3_CUTOFFS_DATES,
  MIDNIGHT_MARCHONQUELDANAS_DATES,
  MIDNIGHT_SEASON1_DATES,
  MIDNIGHT_SEASON1_MYTHIC_DATES,
  TWW_BRD_END_DATES,
  TWW_BRD_START_DATES,
  TWW_GLOBAL_LAUNCH_DATES,
  TWW_PREPATCH_LAUNCH_DATES,
  TWW_SEASON1_DATES,
  TWW_SEASON2_DATES,
  TWW_SEASON3_DATES,
  MIDNIGHT_SPOREFALL_DATES,
  MIDNIGHT_SEASON2_DATES
} from './dates';
import { TRaidMetadata } from './types';
import moment from 'moment';
import { RaidDifficulty } from '../sharedTypes';
import { FATED_ID_OFFSET } from '../raids';

// mapId comes from: https://wow.tools/dbc/?dbc=map (is mapId even used here? We should use what's in db i guess?)
export const RAID_METADATA: TRaidMetadata[] = [
  {
    name: 'The Tidebound Grotto',
    short_name: 'TG',
    slug: 'the-tidebound-grotto',
    icon: 'achievement_boss_elitenagamale',
    mapId: 16671,
    tier: '36',
    ordinal: 29,
    numEncounters: 1,
    expansion: Expansion.Midnight,
    patch: ExpansionPatch.Patch_1210,
    supportedDifficulties: [RaidDifficulty.MYTHIC, RaidDifficulty.HEROIC, RaidDifficulty.NORMAL],
    membersNeededForKill: CURRENT_TIER_RAID_KILLCOUNT,
    supportsFactions: false,
    supportsWorldFirstTracker: true,
    supportsLogging: true,
    supportsGraphs: true,
    supportsGlobalCoverage: false,
    supportsTalentTrees: true,
    leaderboardByBestPull: true,
    dataProviders: FULL_MOMENTO_DATA_PROVIDERS,
    starts: MIDNIGHT_SEASON2_DATES,
    difficultyStarts: {
      [RaidDifficulty.MYTHIC]: MIDNIGHT_SEASON2_DATES
    },
    ends: {
      us: FAR_FUTURE_DATE,
      eu: FAR_FUTURE_DATE,
      tw: FAR_FUTURE_DATE,
      kr: FAR_FUTURE_DATE,
      cn: FAR_FUTURE_DATE
    }
  },
  {
    name: 'The Venomous Abyss',
    short_name: 'VA',
    slug: 'the-venomous-abyss',
    icon: '8039569',
    mapId: 3004,
    tier: '36',
    ordinal: 30,
    numEncounters: 8,
    expansion: Expansion.Midnight,
    patch: ExpansionPatch.Patch_1210,
    supportedDifficulties: [RaidDifficulty.MYTHIC, RaidDifficulty.HEROIC, RaidDifficulty.NORMAL],
    membersNeededForKill: CURRENT_TIER_RAID_KILLCOUNT,
    supportsFactions: false,
    supportsWorldFirstTracker: true,
    supportsLogging: true,
    supportsGraphs: true,
    supportsGlobalCoverage: true,
    supportsTalentTrees: true,
    leaderboardByBestPull: true,
    dataProviders: FULL_MOMENTO_DATA_PROVIDERS,
    starts: MIDNIGHT_SEASON2_DATES,
    difficultyStarts: {
      [RaidDifficulty.MYTHIC]: MIDNIGHT_SEASON2_DATES
    },
    ends: {
      us: FAR_FUTURE_DATE,
      eu: FAR_FUTURE_DATE,
      tw: FAR_FUTURE_DATE,
      kr: FAR_FUTURE_DATE,
      cn: FAR_FUTURE_DATE
    }
  },
  {
    name: 'Sporefall',
    short_name: 'SF',
    slug: 'sporefall',
    icon: 'inv_1207_achievement_raid_fungariangiant_fungalgiant',
    mapId: 1592,
    tier: '35_5',
    ordinal: 28,
    numEncounters: 1,
    expansion: Expansion.Midnight,
    patch: ExpansionPatch.Patch_1207,
    supportedDifficulties: [RaidDifficulty.MYTHIC, RaidDifficulty.HEROIC, RaidDifficulty.NORMAL],
    membersNeededForKill: CURRENT_TIER_RAID_KILLCOUNT,
    supportsFactions: false,
    supportsWorldFirstTracker: true,
    supportsLogging: true,
    supportsGraphs: true,
    supportsGlobalCoverage: true,
    supportsTalentTrees: true,
    leaderboardByBestPull: true,
    dataProviders: FULL_MOMENTO_DATA_PROVIDERS,
    starts: MIDNIGHT_SPOREFALL_DATES,
    ends: MIDNIGHT_SEASON2_DATES
  },
  {
    name: 'Tier 35 (VS / DR / MQD)',
    short_name: 'VS/DR/MQD',
    slug: 'tier-mn-1',
    icon: 'inv_achievement_raid_darkwell',
    mapId: 2912,
    tier: '35',
    ordinal: 27,
    numEncounters: 9,
    expansion: Expansion.Midnight,
    patch: ExpansionPatch.Patch_1200,
    supportedDifficulties: [RaidDifficulty.MYTHIC, RaidDifficulty.HEROIC, RaidDifficulty.NORMAL],
    membersNeededForKill: CURRENT_TIER_RAID_KILLCOUNT,
    supportsFactions: false,
    supportsWorldFirstTracker: true,
    supportsLogging: true,
    supportsGraphs: true,
    supportsGlobalCoverage: true,
    supportsTalentTrees: true,
    leaderboardByBestPull: true,
    dataProviders: FULL_MOMENTO_DATA_PROVIDERS,
    starts: MIDNIGHT_SEASON1_DATES,
    difficultyStarts: {
      [RaidDifficulty.MYTHIC]: MIDNIGHT_SEASON1_MYTHIC_DATES
    },
    ends: MIDNIGHT_SEASON2_DATES,
    partitions: [
      {
        name: 'The Voidspire',
        slug: 'the-voidspire',
        mapId: 2912,
        bossEncounterIds: [3176, 3177, 3179, 3178, 3180, 3181],
        opensAt: MIDNIGHT_SEASON1_DATES
      },
      {
        name: 'The Dreamrift',
        slug: 'the-dreamrift',
        mapId: 2939,
        bossEncounterIds: [3306],
        opensAt: MIDNIGHT_SEASON1_DATES
      },
      {
        name: 'March on Quel\'Danas',
        slug: 'march-on-queldanas',
        mapId: 2913,
        bossEncounterIds: [3182, 3183],
        opensAt: MIDNIGHT_MARCHONQUELDANAS_DATES
      }
    ]
  },
  {
    name: 'Manaforge Omega',
    short_name: 'MFO',
    slug: 'manaforge-omega',
    icon: 'inv_112_achievement_raid_manaforgeomega',
    mapId: 2810,
    tier: '34',
    ordinal: 26,
    numEncounters: 8,
    expansion: Expansion.TheWarWithin,
    patch: ExpansionPatch.Patch_1120,
    supportedDifficulties: [RaidDifficulty.MYTHIC, RaidDifficulty.HEROIC, RaidDifficulty.NORMAL],
    membersNeededForKill: CURRENT_TIER_RAID_KILLCOUNT,
    supportsFactions: false,
    supportsWorldFirstTracker: true,
    supportsLogging: true,
    supportsGraphs: true,
    supportsGlobalCoverage: true,
    supportsTalentTrees: true,
    leaderboardByBestPull: true,
    dataProviders: FULL_MOMENTO_DATA_PROVIDERS,
    starts: TWW_SEASON3_DATES,
    difficultyStarts: {
      [RaidDifficulty.MYTHIC]: TWW_SEASON3_DATES
    },
    ends: MIDNIGHT_GLOBAL_LAUNCH_DATES,
    cutoffsEnds: TWW_SEASON3_CUTOFFS_DATES
  },
  {
    name: 'Liberation of Undermine',
    short_name: 'LOU',
    slug: 'liberation-of-undermine',
    icon: 'inv_achievement_zone_undermine',
    mapId: 2769,
    tier: '33',
    ordinal: 25,
    numEncounters: 8,
    expansion: Expansion.TheWarWithin,
    patch: ExpansionPatch.Patch_1110,
    supportedDifficulties: [RaidDifficulty.MYTHIC, RaidDifficulty.HEROIC, RaidDifficulty.NORMAL],
    membersNeededForKill: CURRENT_TIER_RAID_KILLCOUNT,
    supportsFactions: false,
    supportsWorldFirstTracker: true,
    supportsLogging: true,
    supportsGraphs: true,
    supportsGlobalCoverage: true,
    supportsTalentTrees: true,
    leaderboardByBestPull: true,
    dataProviders: FULL_MOMENTO_DATA_PROVIDERS,
    starts: TWW_SEASON2_DATES,
    difficultyStarts: {
      [RaidDifficulty.MYTHIC]: TWW_SEASON2_DATES
    },
    ends: TWW_SEASON3_DATES
  },
  {
    name: 'Nerub-ar Palace',
    short_name: 'NP',
    slug: 'nerubar-palace',
    icon: 'achievement_zone_azjkahet',
    mapId: 2657,
    tier: '32',
    ordinal: 24,
    numEncounters: 8,
    expansion: Expansion.TheWarWithin,
    patch: ExpansionPatch.Patch_1100,
    supportedDifficulties: [RaidDifficulty.MYTHIC, RaidDifficulty.HEROIC, RaidDifficulty.NORMAL],
    membersNeededForKill: CURRENT_TIER_RAID_KILLCOUNT,
    supportsFactions: false,
    supportsWorldFirstTracker: true,
    supportsLogging: true,
    supportsGraphs: true,
    supportsGlobalCoverage: true,
    supportsTalentTrees: true,
    leaderboardByBestPull: true,
    dataProviders: FULL_MOMENTO_DATA_PROVIDERS,
    starts: TWW_SEASON1_DATES,
    ends: TWW_SEASON2_DATES
  },
  {
    name: 'Blackrock Depths',
    short_name: 'BRD',
    slug: 'blackrock-depths',
    icon: 'achievement_zone_blackrock_01',
    mapId: 2792,
    tier: '32',
    ordinal: 23,
    numEncounters: 8,
    supportedDifficulties: [RaidDifficulty.HEROIC, RaidDifficulty.NORMAL],
    expansion: Expansion.TheWarWithin,
    patch: ExpansionPatch.Patch_1105,
    membersNeededForKill: CURRENT_TIER_RAID_KILLCOUNT,
    supportsFactions: false,
    supportsWorldFirstTracker: false,
    supportsLogging: true,
    supportsGraphs: true,
    supportsGlobalCoverage: false,
    supportsTalentTrees: true,
    leaderboardByBestPull: true,
    dataProviders: FULL_MOMENTO_DATA_PROVIDERS,
    starts: TWW_BRD_START_DATES,
    ends: TWW_BRD_END_DATES
  },

  {
    name: "Awakened Amirdrassil, the Dream's Hope",
    short_name: 'AAMIR',
    slug: 'awakened-amirdrassil-the-dreams-hope',
    icon: 'inv_achievement_raidemeralddream_raid',
    mapId: 2549 + FATED_ID_OFFSET,
    tier: '31_5',
    ordinal: 22,
    numEncounters: 9,
    expansion: Expansion.Dragonflight,
    patch: ExpansionPatch.Patch_1026,
    membersNeededForKill: CURRENT_TIER_RAID_KILLCOUNT,
    supportedDifficulties: [RaidDifficulty.MYTHIC, RaidDifficulty.HEROIC, RaidDifficulty.NORMAL],
    supportsFactions: true,
    supportsWorldFirstTracker: true,
    supportsLogging: true,
    supportsGraphs: true,
    // supportsGlobalCoverage: true,
    supportsTalentTrees: true,
    leaderboardByBestPull: true,
    globalCoverageSlug: 'dragonflight-awakened-raids-season-4',
    globalCoverageTitle: 'Dragonflight Awakened Raids: Season 4',
    hideCharacterBossKills: true,
    dataProviders: FULL_MOMENTO_DATA_PROVIDERS,
    difficultyStarts: {
      [RaidDifficulty.MYTHIC]: {
        us: moment.utc('2024-05-07T15:00:00'),
        eu: moment.utc('2024-05-08T04:00:00'),
        tw: moment.utc('2024-05-08T23:00:00'),
        kr: moment.utc('2024-05-08T23:00:00'),
        cn: moment.utc('2024-05-08T23:00:00')
      }
    },
    fatedInterval: {
      weeks: 3,
      weeksActive: 1,
      rotationStartsAt: {
        us: moment.utc('2024-05-07T15:00:00'),
        eu: moment.utc('2024-05-08T04:00:00'),
        tw: moment.utc('2024-05-08T23:00:00'),
        kr: moment.utc('2024-05-08T23:00:00'),
        cn: moment.utc('2024-05-08T23:00:00')
      },
      rotationEndsAt: TWW_PREPATCH_LAUNCH_DATES,
      alwaysActiveAfterRotationEnds: true,
      alwaysActiveEndsAt: TWW_GLOBAL_LAUNCH_DATES
    },
    starts: {
      us: moment.utc('2024-05-07T15:00:00'),
      eu: moment.utc('2024-05-08T04:00:00'),
      tw: moment.utc('2024-05-08T23:00:00'),
      kr: moment.utc('2024-05-08T23:00:00'),
      cn: moment.utc('2024-05-08T23:00:00')
    },
    ends: TWW_GLOBAL_LAUNCH_DATES
  },
  {
    name: 'Awakened Aberrus, the Shadowed Crucible',
    short_name: 'AATSC',
    slug: 'awakened-aberrus-the-shadowed-crucible',
    icon: 'inv_achievement_raiddragon_raid',
    mapId: 2569 + FATED_ID_OFFSET,
    tier: '31_5',
    ordinal: 21,
    numEncounters: 9,
    supportedDifficulties: [RaidDifficulty.MYTHIC, RaidDifficulty.HEROIC, RaidDifficulty.NORMAL],
    expansion: Expansion.Dragonflight,
    patch: ExpansionPatch.Patch_1026,
    membersNeededForKill: CURRENT_TIER_RAID_KILLCOUNT,
    supportsFactions: true,
    supportsWorldFirstTracker: true,
    supportsLogging: true,
    supportsGraphs: true,
    leaderboardByBestPull: true,
    // supportsGlobalCoverage: true,
    supportsTalentTrees: true,
    globalCoverageSlug: 'dragonflight-awakened-raids-season-4',
    globalCoverageTitle: 'Dragonflight Awakened Raids: Season 4',
    hideCharacterBossKills: true,
    dataProviders: FULL_MOMENTO_DATA_PROVIDERS,
    difficultyStarts: {
      [RaidDifficulty.MYTHIC]: {
        us: moment.utc('2024-04-30T15:00:00'),
        eu: moment.utc('2024-05-01T04:00:00'),
        tw: moment.utc('2024-05-01T23:00:00'),
        kr: moment.utc('2024-05-01T23:00:00'),
        cn: moment.utc('2024-05-01T23:00:00')
      }
    },
    fatedInterval: {
      weeks: 3,
      weeksActive: 1,
      rotationStartsAt: {
        us: moment.utc('2024-04-30T15:00:00'),
        eu: moment.utc('2024-05-01T04:00:00'),
        tw: moment.utc('2024-05-01T23:00:00'),
        kr: moment.utc('2024-05-01T23:00:00'),
        cn: moment.utc('2024-05-01T23:00:00')
      },
      rotationEndsAt: TWW_PREPATCH_LAUNCH_DATES,
      alwaysActiveAfterRotationEnds: true,
      alwaysActiveEndsAt: TWW_GLOBAL_LAUNCH_DATES
    },
    starts: {
      us: moment.utc('2024-04-30T15:00:00'),
      eu: moment.utc('2024-05-01T04:00:00'),
      tw: moment.utc('2024-05-01T23:00:00'),
      kr: moment.utc('2024-05-01T23:00:00'),
      cn: moment.utc('2024-05-01T23:00:00')
    },
    ends: TWW_GLOBAL_LAUNCH_DATES
  },
  {
    name: 'Awakened Vault of the Incarnates',
    short_name: 'AVOTI',
    slug: 'awakened-vault-of-the-incarnates',
    icon: 'achievement_raidprimalist_raid',
    mapId: 2522 + FATED_ID_OFFSET,
    tier: '31_5',
    ordinal: 20,
    numEncounters: 8,
    supportedDifficulties: [RaidDifficulty.MYTHIC, RaidDifficulty.HEROIC, RaidDifficulty.NORMAL],
    expansion: Expansion.Dragonflight,
    patch: ExpansionPatch.Patch_1026,
    membersNeededForKill: CURRENT_TIER_RAID_KILLCOUNT,
    supportsFactions: true,
    supportsWorldFirstTracker: true,
    supportsLogging: true,
    supportsGraphs: true,
    leaderboardByBestPull: true,
    // supportsGlobalCoverage: true,
    supportsTalentTrees: true,
    globalCoverageSlug: 'dragonflight-awakened-raids-season-4',
    globalCoverageTitle: 'Dragonflight Awakened Raids: Season 4',
    hideCharacterBossKills: true,
    dataProviders: FULL_MOMENTO_DATA_PROVIDERS,
    fatedInterval: {
      weeks: 3,
      weeksActive: 1,
      rotationStartsAt: {
        us: moment.utc('2024-04-23T15:00:00'),
        eu: moment.utc('2024-04-24T04:00:00'),
        tw: moment.utc('2024-04-24T23:00:00'),
        kr: moment.utc('2024-04-24T23:00:00'),
        cn: moment.utc('2024-04-24T23:00:00')
      },
      rotationEndsAt: TWW_PREPATCH_LAUNCH_DATES,
      alwaysActiveAfterRotationEnds: true,
      alwaysActiveEndsAt: TWW_GLOBAL_LAUNCH_DATES
    },
    starts: {
      us: moment.utc('2024-04-23T15:00:00'),
      eu: moment.utc('2024-04-24T04:00:00'),
      tw: moment.utc('2024-04-24T23:00:00'),
      kr: moment.utc('2024-04-24T23:00:00'),
      cn: moment.utc('2024-04-24T23:00:00')
    },
    ends: TWW_GLOBAL_LAUNCH_DATES
  },

  {
    name: "Amirdrassil, the Dream's Hope",
    short_name: 'AMIR',
    slug: 'amirdrassil-the-dreams-hope',
    icon: 'inv_achievement_raidemeralddream_raid',
    mapId: 2549,
    tier: '31',
    ordinal: 19,
    numEncounters: 9,
    supportedDifficulties: [RaidDifficulty.MYTHIC, RaidDifficulty.HEROIC, RaidDifficulty.NORMAL],
    expansion: Expansion.Dragonflight,
    patch: ExpansionPatch.Patch_1020,
    membersNeededForKill: CURRENT_TIER_RAID_KILLCOUNT,
    supportsFactions: false,
    supportsWorldFirstTracker: true,
    supportsLogging: true,
    supportsGlobalCoverage: true,
    supportsGraphs: true,
    supportsTalentTrees: true,
    leaderboardByBestPull: true,
    disabledRegions: ['cn'],
    dataProviders: FULL_MOMENTO_DATA_PROVIDERS,
    starts: DF_SEASON3_DATES,
    difficultyStarts: {
      [RaidDifficulty.MYTHIC]: DF_SEASON3_DATES
    },
    ends: DF_SEASON4_DATES
  },
  {
    name: 'Aberrus, the Shadowed Crucible',
    short_name: 'ATSC',
    slug: 'aberrus-the-shadowed-crucible',
    icon: 'inv_achievement_raiddragon_raid',
    mapId: 2569,
    tier: '30',
    ordinal: 18,
    numEncounters: 9,
    supportedDifficulties: [RaidDifficulty.MYTHIC, RaidDifficulty.HEROIC, RaidDifficulty.NORMAL],
    expansion: Expansion.Dragonflight,
    patch: ExpansionPatch.Patch_1010,
    membersNeededForKill: CURRENT_TIER_RAID_KILLCOUNT,
    supportsFactions: false,
    supportsWorldFirstTracker: true,
    supportsLogging: true,
    supportsGlobalCoverage: true,
    supportsGraphs: true,
    supportsTalentTrees: true,
    leaderboardByBestPull: true,
    disabledRegions: ['cn'],
    dataProviders: FULL_MOMENTO_DATA_PROVIDERS,
    starts: DF_SEASON2_DATES,
    difficultyStarts: {
      [RaidDifficulty.MYTHIC]: DF_SEASON2_DATES
    },
    ends: DF_SEASON3_DATES
  },
  {
    name: 'Vault of the Incarnates',
    short_name: 'VOTI',
    slug: 'vault-of-the-incarnates',
    icon: 'achievement_raidprimalist_raid',
    mapId: 2522,
    tier: '29',
    ordinal: 17,
    numEncounters: 8,
    supportedDifficulties: [RaidDifficulty.MYTHIC, RaidDifficulty.HEROIC, RaidDifficulty.NORMAL],
    expansion: Expansion.Dragonflight,
    patch: ExpansionPatch.Patch_1002,
    membersNeededForKill: CURRENT_TIER_RAID_KILLCOUNT,
    supportsFactions: true,
    supportsWorldFirstTracker: true,
    supportsLogging: true,
    supportsGlobalCoverage: true,
    supportsGraphs: true,
    supportsTalentTrees: true,
    leaderboardByBestPull: true,
    dataProviders: FULL_MOMENTO_DATA_PROVIDERS,
    starts: DF_SEASON1_DATES,
    difficultyStarts: {
      [RaidDifficulty.MYTHIC]: DF_SEASON1_DATES
    },
    ends: DF_SEASON2_DATES
  },
  {
    name: 'Fated Sepulcher of the First Ones',
    short_name: 'FSFO',
    slug: 'fated-sepulcher-of-the-first-ones',
    icon: 'inv_achievement_raid_progenitorraid',
    mapId: 100002481,
    tier: '28_5',
    ordinal: 16,
    numEncounters: 11,
    supportedDifficulties: [RaidDifficulty.MYTHIC, RaidDifficulty.HEROIC, RaidDifficulty.NORMAL],
    expansion: Expansion.Shadowlands,
    patch: ExpansionPatch.Patch_925,
    membersNeededForKill: CURRENT_TIER_RAID_KILLCOUNT,
    supportsFactions: true,
    supportsWorldFirstTracker: true,
    supportsLogging: true,
    supportsGraphs: true,
    supportsGlobalCoverage: true,
    supportsTalentTrees: true,
    globalCoverageSlug: 'shadowlands-fated-raids-season-4',
    globalCoverageTitle: 'Shadowlands Fated Raids: Season 4',
    hideCharacterBossKills: true,
    dataProviders: FULL_MOMENTO_DATA_PROVIDERS,
    fatedInterval: {
      weeks: 3,
      weeksActive: 1,
      rotationStartsAt: {
        us: moment.utc('2022-08-16T15:00:00'),
        eu: moment.utc('2022-08-17T07:00:00'),
        tw: moment.utc('2022-08-17T23:00:00'),
        kr: moment.utc('2022-08-17T23:00:00'),
        cn: moment.utc('2022-08-17T23:00:00')
      },
      rotationEndsAt: DF_PREPATCH_LAUNCH_DATES,
      alwaysActiveAfterRotationEnds: true,
      alwaysActiveEndsAt: {
        us: DF_LAUNCH_DATE,
        eu: DF_LAUNCH_DATE,
        tw: DF_LAUNCH_DATE,
        kr: DF_LAUNCH_DATE,
        cn: DF_LAUNCH_DATE
      }
    },
    starts: {
      us: moment.utc('2022-08-16T15:00:00'),
      eu: moment.utc('2022-08-17T07:00:00'),
      tw: moment.utc('2022-08-17T23:00:00'),
      kr: moment.utc('2022-08-17T23:00:00'),
      cn: moment.utc('2022-08-17T23:00:00')
    },
    ends: {
      us: DF_LAUNCH_DATE,
      eu: DF_LAUNCH_DATE,
      tw: DF_LAUNCH_DATE,
      kr: DF_LAUNCH_DATE,
      cn: DF_LAUNCH_DATE
    }
  },
  {
    name: 'Fated Sanctum of Domination',
    short_name: 'FSOD',
    slug: 'fated-sanctum-of-domination',
    icon: 'achievement_raid_torghastraid',
    mapId: 100002450,
    tier: '28_5',
    ordinal: 15,
    numEncounters: 10,
    supportedDifficulties: [RaidDifficulty.MYTHIC, RaidDifficulty.HEROIC, RaidDifficulty.NORMAL],
    expansion: Expansion.Shadowlands,
    patch: ExpansionPatch.Patch_925,
    membersNeededForKill: CURRENT_TIER_RAID_KILLCOUNT,
    supportsFactions: true,
    supportsWorldFirstTracker: true,
    supportsLogging: true,
    supportsGraphs: true,
    supportsGlobalCoverage: true,
    supportsTalentTrees: true,
    globalCoverageSlug: 'shadowlands-fated-raids-season-4',
    globalCoverageTitle: 'Shadowlands Fated Raids: Season 4',
    hideCharacterBossKills: true,
    dataProviders: FULL_MOMENTO_DATA_PROVIDERS,
    fatedInterval: {
      weeks: 3,
      weeksActive: 1,
      rotationStartsAt: {
        us: moment.utc('2022-08-09T15:00:00'),
        eu: moment.utc('2022-08-10T07:00:00'),
        tw: moment.utc('2022-08-10T23:00:00'),
        kr: moment.utc('2022-08-10T23:00:00'),
        cn: moment.utc('2022-08-10T23:00:00')
      },
      rotationEndsAt: DF_PREPATCH_LAUNCH_DATES,
      alwaysActiveAfterRotationEnds: true,
      alwaysActiveEndsAt: {
        us: DF_LAUNCH_DATE,
        eu: DF_LAUNCH_DATE,
        tw: DF_LAUNCH_DATE,
        kr: DF_LAUNCH_DATE,
        cn: DF_LAUNCH_DATE
      }
    },
    starts: {
      us: moment.utc('2022-08-09T15:00:00'),
      eu: moment.utc('2022-08-10T07:00:00'),
      tw: moment.utc('2022-08-10T23:00:00'),
      kr: moment.utc('2022-08-10T23:00:00'),
      cn: moment.utc('2022-08-10T23:00:00')
    },
    ends: {
      us: DF_LAUNCH_DATE,
      eu: DF_LAUNCH_DATE,
      tw: DF_LAUNCH_DATE,
      kr: DF_LAUNCH_DATE,
      cn: DF_LAUNCH_DATE
    }
  },
  {
    name: 'Fated Castle Nathria',
    short_name: 'FCN',
    slug: 'fated-castle-nathria',
    icon: 'achievement_raid_revendrethraid_castlenathria',
    mapId: 100002296,
    tier: '28_5',
    ordinal: 14,
    numEncounters: 10,
    supportedDifficulties: [RaidDifficulty.MYTHIC, RaidDifficulty.HEROIC, RaidDifficulty.NORMAL],
    expansion: Expansion.Shadowlands,
    patch: ExpansionPatch.Patch_925,
    membersNeededForKill: CURRENT_TIER_RAID_KILLCOUNT,
    supportsFactions: true,
    supportsWorldFirstTracker: true,
    supportsLogging: true,
    supportsGraphs: true,
    supportsGlobalCoverage: true,
    supportsTalentTrees: true,
    globalCoverageSlug: 'shadowlands-fated-raids-season-4',
    globalCoverageTitle: 'Shadowlands Fated Raids: Season 4',
    hideCharacterBossKills: true,
    dataProviders: FULL_MOMENTO_DATA_PROVIDERS,
    fatedInterval: {
      weeks: 3,
      weeksActive: 1,
      rotationStartsAt: {
        us: moment.utc('2022-08-02T15:00:00'),
        eu: moment.utc('2022-08-03T07:00:00'),
        tw: moment.utc('2022-08-03T23:00:00'),
        kr: moment.utc('2022-08-03T23:00:00'),
        cn: moment.utc('2022-08-03T23:00:00')
      },
      rotationEndsAt: DF_PREPATCH_LAUNCH_DATES,
      alwaysActiveAfterRotationEnds: true,
      alwaysActiveEndsAt: {
        us: DF_LAUNCH_DATE,
        eu: DF_LAUNCH_DATE,
        tw: DF_LAUNCH_DATE,
        kr: DF_LAUNCH_DATE,
        cn: DF_LAUNCH_DATE
      }
    },
    starts: {
      us: moment.utc('2022-08-02T15:00:00'),
      eu: moment.utc('2022-08-03T07:00:00'),
      tw: moment.utc('2022-08-03T23:00:00'),
      kr: moment.utc('2022-08-03T23:00:00'),
      cn: moment.utc('2022-08-03T23:00:00')
    },
    ends: {
      us: DF_LAUNCH_DATE,
      eu: DF_LAUNCH_DATE,
      tw: DF_LAUNCH_DATE,
      kr: DF_LAUNCH_DATE,
      cn: DF_LAUNCH_DATE
    }
  },

  {
    name: 'Sepulcher of the First Ones',
    short_name: 'SFO',
    slug: 'sepulcher-of-the-first-ones',
    icon: 'inv_achievement_raid_progenitorraid',
    mapId: 2481,
    tier: '28',
    ordinal: 13,
    numEncounters: 11,
    supportedDifficulties: [RaidDifficulty.MYTHIC, RaidDifficulty.HEROIC, RaidDifficulty.NORMAL],
    expansion: Expansion.Shadowlands,
    patch: ExpansionPatch.Patch_920,
    membersNeededForKill: CURRENT_TIER_RAID_KILLCOUNT,
    supportsFactions: true,
    supportsWorldFirstTracker: true,
    supportsLogging: true,
    supportsGlobalCoverage: true,
    supportsGraphs: true,
    dataProviders: FULL_MOMENTO_DATA_PROVIDERS,
    starts: {
      us: moment.utc('2022-03-01T15:00:00'),
      eu: moment.utc('2022-03-02T07:00:00'),
      tw: moment.utc('2022-03-02T23:00:00'),
      kr: moment.utc('2022-03-02T23:00:00'),
      cn: moment.utc('2022-03-02T23:00:00')
    },
    ends: {
      us: moment.utc('2022-08-02T15:00:00'),
      eu: moment.utc('2022-08-03T07:00:00'),
      tw: moment.utc('2022-08-03T23:00:00'),
      kr: moment.utc('2022-08-03T23:00:00'),
      cn: moment.utc('2022-08-03T23:00:00')
    }
  },
  {
    name: 'Sanctum of Domination',
    short_name: 'SOD',
    slug: 'sanctum-of-domination',
    icon: 'achievement_raid_torghastraid',
    mapId: 2450,
    tier: '27',
    ordinal: 12,
    numEncounters: 10,
    supportedDifficulties: [RaidDifficulty.MYTHIC, RaidDifficulty.HEROIC, RaidDifficulty.NORMAL],
    expansion: Expansion.Shadowlands,
    patch: ExpansionPatch.Patch_910,
    membersNeededForKill: CURRENT_TIER_CROSSSERVER_RAID_KILLCOUNT,
    supportsFactions: true,
    supportsWorldFirstTracker: true,
    supportsLogging: true,
    supportsGlobalCoverage: true,
    supportsGraphs: true,
    dataProviders: FULL_MOMENTO_DATA_PROVIDERS,
    starts: {
      us: moment.utc('2021-07-06T15:00:00'),
      eu: moment.utc('2021-07-07T07:00:00'),
      tw: moment.utc('2021-07-07T23:00:00'),
      kr: moment.utc('2021-07-07T23:00:00'),
      cn: moment.utc('2021-07-07T23:00:00')
    },
    ends: {
      us: moment.utc('2022-02-22T15:00:00'),
      eu: moment.utc('2022-02-23T07:00:00'),
      tw: moment.utc('2022-02-23T23:00:00'),
      kr: moment.utc('2022-02-23T23:00:00'),
      cn: moment.utc('2022-02-23T23:00:00')
    }
  },
  {
    name: 'Castle Nathria',
    short_name: 'CN',
    slug: 'castle-nathria',
    icon: 'achievement_raid_revendrethraid_castlenathria',
    mapId: 2296,
    tier: '26',
    ordinal: 11,
    numEncounters: 10,
    supportedDifficulties: [RaidDifficulty.MYTHIC, RaidDifficulty.HEROIC, RaidDifficulty.NORMAL],
    expansion: Expansion.Shadowlands,
    patch: ExpansionPatch.Patch_902,
    membersNeededForKill: PREVIOUS_TIER_RAID_KILLCOUNT,
    supportsFactions: true,
    supportsWorldFirstTracker: true,
    supportsLogging: true,
    supportsGlobalCoverage: true,
    dataProviders: FULL_MOMENTO_DATA_PROVIDERS,
    starts: {
      us: moment.utc('2020-12-08T15:00:00'),
      eu: moment.utc('2020-12-09T07:00:00'),
      tw: moment.utc('2020-12-09T23:00:00'),
      kr: moment.utc('2020-12-09T23:00:00'),
      cn: moment.utc('2020-12-09T23:00:00')
    },
    ends: {
      us: moment.utc('2021-06-29T15:00:00'),
      eu: moment.utc('2021-06-30T07:00:00'),
      tw: moment.utc('2021-06-30T23:00:00'),
      kr: moment.utc('2021-06-30T23:00:00'),
      cn: moment.utc('2021-06-30T23:00:00')
    }
  },
  {
    name: "Ny'alotha, the Waking City",
    short_name: 'NYA',
    slug: 'nyalotha-the-waking-city',
    icon: 'achievement_nzothraid_nzoth',
    mapId: 2217,
    tier: '25',
    ordinal: 10,
    numEncounters: 12,
    supportedDifficulties: [RaidDifficulty.MYTHIC, RaidDifficulty.HEROIC, RaidDifficulty.NORMAL],
    expansion: Expansion.BattleForAzeroth,
    patch: ExpansionPatch.Patch_830,
    membersNeededForKill: PREVIOUS_TIER_RAID_KILLCOUNT,
    supportsFactions: true,
    supportsWorldFirstTracker: true,
    dataProviders: FULL_MOMENTO_DATA_PROVIDERS,
    starts: {
      us: moment.utc('2020-01-21T15:00:00'),
      eu: moment.utc('2020-01-22T07:00:00'),
      tw: moment.utc('2020-01-22T23:00:00'),
      kr: moment.utc('2020-01-22T23:00:00'),
      cn: moment.utc('2020-01-22T23:00:00')
    },
    ends: {
      us: moment.utc('2020-10-13T15:00:00'),
      eu: moment.utc('2020-10-14T07:00:00'),
      tw: moment.utc('2020-10-14T23:00:00'),
      kr: moment.utc('2020-10-14T23:00:00'),
      cn: moment.utc('2020-10-14T23:00:00')
    }
  },
  {
    name: 'The Eternal Palace',
    short_name: 'EP',
    slug: 'the-eternal-palace',
    icon: 'achievement_boss_azshara',
    mapId: 2164,
    tier: '24',
    numEncounters: 8,
    supportedDifficulties: [RaidDifficulty.MYTHIC, RaidDifficulty.HEROIC, RaidDifficulty.NORMAL],
    ordinal: 9,
    expansion: Expansion.BattleForAzeroth,
    patch: ExpansionPatch.Patch_820,
    membersNeededForKill: PREVIOUS_TIER_RAID_KILLCOUNT,
    supportsFactions: true,
    supportsWorldFirstTracker: true,
    dataProviders: FULL_MOMENTO_DATA_PROVIDERS,
    starts: {
      us: moment.utc('2019-07-09T15:00:00'),
      eu: moment.utc('2019-07-10T07:00:00'),
      tw: moment.utc('2019-07-10T23:00:00'),
      kr: moment.utc('2019-07-10T23:00:00'),
      cn: moment.utc('2019-07-10T23:00:00')
    },
    ends: {
      us: moment.utc('2020-01-21T15:00:00'),
      eu: moment.utc('2020-01-22T07:00:00'),
      tw: moment.utc('2020-01-22T23:00:00'),
      kr: moment.utc('2020-01-22T23:00:00'),
      cn: moment.utc('2020-01-22T23:00:00')
    }
  },
  {
    name: 'Crucible of Storms',
    short_name: 'COS',
    slug: 'crucible-of-storms',
    icon: 'achievement_uunat',
    mapId: 2096,
    tier: '23',
    numEncounters: 2,
    supportedDifficulties: [RaidDifficulty.MYTHIC, RaidDifficulty.HEROIC, RaidDifficulty.NORMAL],
    ordinal: 8,
    expansion: Expansion.BattleForAzeroth,
    patch: ExpansionPatch.Patch_810,
    membersNeededForKill: PREVIOUS_TIER_RAID_KILLCOUNT,
    supportsFactions: true,
    supportsWorldFirstTracker: true,
    dataProviders: FULL_MOMENTO_DATA_PROVIDERS,
    starts: {
      us: moment.utc('2019-04-16T15:00:00'),
      eu: moment.utc('2019-04-17T07:00:00'),
      tw: moment.utc('2019-04-17T23:00:00'),
      kr: moment.utc('2019-04-17T23:00:00'),
      cn: moment.utc('2019-04-17T23:00:00')
    },
    ends: {
      us: moment.utc('2019-07-09T15:00:00'),
      eu: moment.utc('2019-07-10T07:00:00'),
      tw: moment.utc('2019-07-10T23:00:00'),
      kr: moment.utc('2019-07-10T23:00:00'),
      cn: moment.utc('2019-07-10T23:00:00')
    }
  },
  {
    name: "Battle of Dazar'alor",
    short_name: 'BOD',
    slug: 'battle-of-dazaralor',
    icon: 'achievement_boss_zuldazar_jaina',
    mapId: 2070,
    tier: '23',
    numEncounters: 9,
    supportedDifficulties: [RaidDifficulty.MYTHIC, RaidDifficulty.HEROIC, RaidDifficulty.NORMAL],
    ordinal: 7,
    expansion: Expansion.BattleForAzeroth,
    patch: ExpansionPatch.Patch_810,
    membersNeededForKill: PREVIOUS_TIER_RAID_KILLCOUNT,
    supportsFactions: true,
    supportsWorldFirstTracker: true,
    dataProviders: FULL_MOMENTO_DATA_PROVIDERS,
    starts: {
      us: moment.utc('2019-01-22T15:00:00'),
      eu: moment.utc('2019-01-23T07:00:00'),
      tw: moment.utc('2019-01-23T23:00:00'),
      kr: moment.utc('2019-01-23T23:00:00'),
      cn: moment.utc('2019-01-23T23:00:00')
    },
    ends: {
      us: moment.utc('2019-07-09T15:00:00'),
      eu: moment.utc('2019-07-10T07:00:00'),
      tw: moment.utc('2019-07-10T23:00:00'),
      kr: moment.utc('2019-07-10T23:00:00'),
      cn: moment.utc('2019-07-10T23:00:00')
    }
  },
  {
    name: 'Uldir',
    short_name: 'ULD',
    slug: 'uldir',
    icon: 'achievement_nazmir_boss_ghuun',
    mapId: 1861,
    tier: '22',
    numEncounters: 8,
    supportedDifficulties: [RaidDifficulty.MYTHIC, RaidDifficulty.HEROIC, RaidDifficulty.NORMAL],
    ordinal: 6,
    expansion: Expansion.BattleForAzeroth,
    patch: ExpansionPatch.Patch_800,
    membersNeededForKill: PREVIOUS_TIER_RAID_KILLCOUNT,
    dataProviders: FULL_MOMENTO_DATA_PROVIDERS,
    starts: {
      us: moment.utc('2018-09-04T15:00:00'),
      eu: moment.utc('2018-09-05T07:00:00'),
      tw: moment.utc('2018-09-05T23:00:00'),
      kr: moment.utc('2018-09-05T23:00:00'),
      cn: moment.utc('2018-09-05T23:00:00')
    },
    ends: {
      us: moment.utc('2019-01-22T15:00:00'),
      eu: moment.utc('2019-01-23T07:00:00'),
      tw: moment.utc('2019-01-23T23:00:00'),
      kr: moment.utc('2019-01-23T23:00:00'),
      cn: moment.utc('2019-01-23T23:00:00')
    }
  },
  {
    name: 'Antorus, the Burning Throne',
    short_name: 'ATBT',
    slug: 'antorus-the-burning-throne',
    mapId: 1712,
    tier: '21',
    numEncounters: 11,
    supportedDifficulties: [RaidDifficulty.MYTHIC, RaidDifficulty.HEROIC, RaidDifficulty.NORMAL],
    ordinal: 5,
    expansion: Expansion.Legion,
    patch: ExpansionPatch.Patch_700,
    membersNeededForKill: PREVIOUS_XPAC_RAID_KILLCOUNT,
    dataProviders: FULL_MOMENTO_DATA_PROVIDERS,
    starts: {
      us: moment.utc('2017-11-28T15:00:00'),
      eu: moment.utc('2017-11-29T07:00:00'),
      tw: moment.utc('2017-11-29T23:00:00'),
      kr: moment.utc('2017-11-29T23:00:00'),
      cn: moment.utc('2017-11-29T23:00:00')
    },
    ends: {
      us: moment.utc('2018-07-17T15:00:00'),
      eu: moment.utc('2018-07-18T07:00:00'),
      tw: moment.utc('2018-07-18T23:00:00'),
      kr: moment.utc('2018-07-18T23:00:00'),
      cn: moment.utc('2018-07-18T23:00:00')
    }
  },
  {
    name: 'Tomb of Sargeras',
    short_name: 'TOS',
    slug: 'tomb-of-sargeras',
    mapId: 1676,
    tier: '20',
    numEncounters: 9,
    supportedDifficulties: [RaidDifficulty.MYTHIC, RaidDifficulty.HEROIC, RaidDifficulty.NORMAL],
    ordinal: 4,
    expansion: Expansion.Legion,
    patch: ExpansionPatch.Patch_700,
    membersNeededForKill: PREVIOUS_XPAC_RAID_KILLCOUNT,
    dataProviders: FULL_MOMENTO_DATA_PROVIDERS,
    starts: {
      us: moment.utc('2017-06-20T15:00:00'),
      eu: moment.utc('2017-06-21T07:00:00'),
      tw: moment.utc('2017-06-21T23:00:00'),
      kr: moment.utc('2017-06-21T23:00:00'),
      cn: moment.utc('2017-06-21T23:00:00')
    },
    ends: {
      us: moment.utc('2017-11-28T15:00:00'),
      eu: moment.utc('2017-11-29T07:00:00'),
      tw: moment.utc('2017-11-29T23:00:00'),
      kr: moment.utc('2017-11-29T23:00:00'),
      cn: moment.utc('2017-11-29T23:00:00')
    }
  },
  {
    name: 'The Nighthold',
    short_name: 'NH',
    slug: 'the-nighthold',
    mapId: 1530,
    tier: '19',
    numEncounters: 10,
    supportedDifficulties: [RaidDifficulty.MYTHIC, RaidDifficulty.HEROIC, RaidDifficulty.NORMAL],
    ordinal: 3,
    expansion: Expansion.Legion,
    patch: ExpansionPatch.Patch_700,
    membersNeededForKill: PREVIOUS_XPAC_RAID_KILLCOUNT,
    dataProviders: FULL_MOMENTO_DATA_PROVIDERS,
    starts: {
      us: moment.utc('2017-01-17T15:00:00'),
      eu: moment.utc('2017-01-18T07:00:00'),
      tw: moment.utc('2017-01-18T23:00:00'),
      kr: moment.utc('2017-01-18T23:00:00'),
      cn: moment.utc('2017-01-18T23:00:00')
    },
    ends: {
      us: moment.utc('2017-06-13T15:00:00'),
      eu: moment.utc('2017-06-14T07:00:00'),
      tw: moment.utc('2017-06-14T23:00:00'),
      kr: moment.utc('2017-06-14T23:00:00'),
      cn: moment.utc('2017-06-14T23:00:00')
    }
  },
  {
    name: 'Trial of Valor',
    short_name: 'TOV',
    slug: 'trial-of-valor',
    mapId: 1648,
    tier: '19',
    numEncounters: 3,
    supportedDifficulties: [RaidDifficulty.MYTHIC],
    ordinal: 2,
    expansion: Expansion.Legion,
    patch: ExpansionPatch.Patch_700,
    membersNeededForKill: PREVIOUS_XPAC_RAID_KILLCOUNT,
    dataProviders: FULL_MOMENTO_DATA_PROVIDERS,
    starts: {
      us: moment.utc('2016-11-08T15:00:00'),
      eu: moment.utc('2016-11-09T07:00:00'),
      tw: moment.utc('2016-11-09T23:00:00'),
      kr: moment.utc('2016-11-09T23:00:00'),
      cn: moment.utc('2016-11-09T23:00:00')
    },
    ends: {
      us: moment.utc('2017-06-13T15:00:00'),
      eu: moment.utc('2017-06-14T07:00:00'),
      tw: moment.utc('2017-06-14T23:00:00'),
      kr: moment.utc('2017-06-14T23:00:00'),
      cn: moment.utc('2017-06-14T23:00:00')
    }
  },
  {
    name: 'The Emerald Nightmare',
    short_name: 'EN',
    slug: 'the-emerald-nightmare',
    mapId: 1520,
    tier: '19',
    numEncounters: 7,
    supportedDifficulties: [RaidDifficulty.MYTHIC],
    ordinal: 1,
    expansion: Expansion.Legion,
    patch: ExpansionPatch.Patch_700,
    membersNeededForKill: PREVIOUS_XPAC_RAID_KILLCOUNT,
    dataProviders: FULL_MOMENTO_DATA_PROVIDERS,
    starts: {
      us: moment.utc('2016-09-20T07:00:00'),
      eu: moment.utc('2016-09-21T07:00:00'),
      tw: moment.utc('2016-09-21T07:00:00'),
      kr: moment.utc('2016-09-21T07:00:00'),
      cn: moment.utc('2016-09-21T07:00:00')
    },
    ends: {
      us: moment.utc('2017-01-10T15:00:00'),
      eu: moment.utc('2017-01-17T07:00:00'),
      tw: moment.utc('2017-01-17T23:00:00'),
      kr: moment.utc('2017-01-17T23:00:00'),
      cn: moment.utc('2017-01-17T23:00:00')
    }
  }
];

const MAX_ALLOWED_ACTIVE_RAID = 4;

// Safety check
{
  const activeRaids = RAID_METADATA.filter((s) => s.ends.us === FAR_FUTURE_DATE).length;
  if (activeRaids > MAX_ALLOWED_ACTIVE_RAID) {
    throw new Error(`There's ${activeRaids} active raids where a maximum of ${MAX_ALLOWED_ACTIVE_RAID} is required.`);
  }

  const uniqRaidId = new Set(RAID_METADATA.map((r) => r.mapId));
  if (uniqRaidId.size !== RAID_METADATA.length) {
    throw new Error(`There are duplicate raid IDs in RAID_METADATA: ${JSON.stringify(RAID_METADATA.map((r) => r.mapId))}`);
  }
}
